var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.9778C1.5 4.23539 1.5 3.3642 1.83909 2.69869C2.13736 2.1133 2.6133 1.63736 3.19869 1.33909C3.8642 1 4.73539 1 6.4778 1H10.5222C12.2646 1 13.1358 1 13.8013 1.33909C14.3867 1.63736 14.8626 2.1133 15.1609 2.69869C15.5 3.3642 15.5 4.23539 15.5 5.9778V10.0222C15.5 11.7646 15.5 12.6358 15.1609 13.3013C14.8626 13.8867 14.3867 14.3626 13.8013 14.6609C13.1358 15 12.2646 15 10.5222 15H6.4778C4.73539 15 3.8642 15 3.19869 14.6609C2.6133 14.3626 2.13736 13.8867 1.83909 13.3013C1.5 12.6358 1.5 11.7646 1.5 10.0222V5.9778Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5258 4.26147L8.5322 6.5977L5.47021 4.26147V4.2621L5.47392 4.26526V7.5366L8.4977 9.9233L11.5258 7.62875V4.26147Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3115 3.69319L11.5254 4.26146V7.62875L13.9991 5.7295V4.58537C13.9991 4.58537 13.6989 2.95129 12.3115 3.69319Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5254 7.62874V11.9962H13.4214C13.4214 11.9962 13.9609 11.9406 13.9997 11.3256V5.72949L11.5254 7.62874Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47405 12V7.5366L5.47021 7.53345L5.47405 12Z",
    fill: "#C5221F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47007 4.26202L4.68823 3.69691C3.3009 2.95501 3 4.58846 3 4.58846V5.73255L5.47007 7.53335V4.26202Z",
    fill: "#C5221F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47021 4.26221V7.53355L5.47405 7.5367V4.26537L5.47021 4.26221Z",
    fill: "#C5221F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.7334V11.3295C3.03823 11.9452 3.57837 12.0001 3.57837 12.0001H5.47438L5.47007 7.53355L3 5.7334Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.5bbed6d52dcc202b59c831e741dac358.svg";
export { ForwardRef as ReactComponent };